<template>
    <div>
        <el-dialog v-model="dialogVisible"   width="700px" :before-close="handleClose"  class="custom-dialog">
            <h3 style="text-align: center; color: #fff; font-size: 18px ">{{loadingTitle}}</h3>
            <el-row type="flex" justify="center" style="margin-top: 30px;"> 
                <el-form :inline="false" :model="devcieInfo" :rules="rules" ref="rulesForm" label-position="right" label-width="auto" >
                    <el-form-item label="设备型号：" prop="model" style="margin-top:10px;">
                        <el-input v-model="devcieInfo.model" maxlength="30" class="upload_form-input_class1"></el-input>
                    </el-form-item>
                    <el-form-item label="设备位号：" prop="sn" style="margin-top: 10px;">
                        <el-input v-model.trim="devcieInfo.sn" maxlength="30" class="upload_form-input_class1"></el-input>
                    </el-form-item>
                    <el-form-item label="设备功率(瓦)：" prop="power" style="margin-top: 10px;">
                        <el-input v-model.number="devcieInfo.power"  maxlength="30" type="number" class="upload_form-input_class1"></el-input>
                    </el-form-item>
                    <el-form-item label="负载输出速度：" prop="load_output_speed" style="margin-top: 10px;">
                        <el-input v-model.number="devcieInfo.load_output_speed"  maxlength="30" type="number" class="upload_form-input_class1"></el-input>
                    </el-form-item>
                    <el-form-item label="电机类型：" prop="is_fix_freq" style="margin-top: 10px;">
                        <el-select v-model="devcieInfo.is_fix_freq"  size="default" clearable   class="upload_form-input_class1">
                        
                        <el-option label="定频" value="1">定频</el-option>
                        <el-option label="变频" value="0">变频</el-option>
                    
                    </el-select>
                       
                    </el-form-item>
                    <el-form-item label="生产厂家：" prop="manufactor" style="margin-top: 10px;">
                        <el-input v-model.trim="devcieInfo.manufactor"  maxlength="30" class="upload_form-input_class1"></el-input>
                    </el-form-item>
                    <el-form-item label="设备位置：" prop="location" style="margin-top: 10px;">
                        <el-input v-model.trim="devcieInfo.location" maxlength="30" class="upload_form-input_class1"></el-input>
                    </el-form-item>

                    <el-form-item label="转速(转/分钟)：" prop="speed" style="margin-top: 10px;">
                        <el-input v-model.number="devcieInfo.speed" maxlength="30" class="upload_form-input_class1"></el-input>
                    </el-form-item>

                    <el-form-item label="算法延时(分钟)：" prop="alg_delay" style="margin-top: 10px;">
                        <el-input v-model.number="devcieInfo.alg_delay" maxlength="30" class="upload_form-input_class1"></el-input>
                    </el-form-item>

                    <el-form-item label="是否输出停机事件：" style="margin-top: -10px;">   
                        <el-radio-group v-model="devcieInfo.enable_stopped_event_output">
                            <el-radio :label="true" style="font-size: 16px;padding-left: 10px;">是</el-radio>
                            <el-radio :label="false" style="font-size: 16px;padding-left: 10px;">否</el-radio>
                        </el-radio-group>
                    </el-form-item>

                </el-form>
            </el-row>
          
            <el-row style="margin-bottom: 5px;" v-if="false">
                <el-col :span="12" style="padding-right:  1px;">
                    <div style="height: 200px;" >
                        <el-upload
                            class="avatar-uploader"
                            action=""
                            :show-file-list="false"
                            ref="uploadDefaultImageDevice"
                            :http-request="imgUploadRequestDevice"
                            :on-success="imgUploadSuccessDevice"
                            :before-upload="imgBeforeUploadDevice">
                            <!-- <img v-if="pic_url" :src="pic_url" class="avatar" alt="图片上传失败！请重新上传！">
                            <el-icon v-else class="avatar-uploader-icon" size="medium"><Plus /><span>图片添加</span></el-icon> -->
                            <img  :src="pic_url" class="avatar" :onerror="defaultAddDevImg">

                        </el-upload>
                    </div>
                    <!-- <div style="display: flex; justify-content: center;margin:5px">
                        <span>设备图片</span>
                    </div> -->
                </el-col>
                <el-col :span="12" style="padding-left: 1px;">
                    <div style="height: 200px; ">
                        <el-upload
                            class="avatar-uploader"
                            action=""
                            :show-file-list="false"
                            ref="uploadDefaultImageEnv"
                            :http-request="imgUploadRequestEnv"
                            :on-success="imgUploadSuccessEnv"
                            :before-upload="imgBeforeUploadEnv">
                            <!-- <img v-if="env_pic_url" :src="env_pic_url" class="avatar" alt="图片上传失败！请重新上传！">
                            <el-icon v-else class="avatar-uploader-icon" size="medium"><Plus /><span>图片添加</span></el-icon> -->
                            <img  :src="env_pic_url" class="avatar" :onerror="defaultAddEnvImg">

                        </el-upload>
                    </div>
                    <!-- <div style="display: flex; justify-content: center; margin:5px">
                        <span>环境图片</span>
                    </div> -->
                </el-col>
            </el-row>

                
            <el-row #default="{row}">
                <el-col style="text-align: center; height: 40px; padding-top: 15px;margin-top: 5px;margin-bottom: 70px;">
                    <el-button type="primary" @click="submitData" :loading="loadingSave" style="width: 90px;">确定</el-button>
                    <el-button @click="handleClose"  style="width: 90px;margin-left: 30px;">取消</el-button>
                </el-col>
            </el-row>

            <!-- <template #footer>
                <el-button @click="handleClose" :loading="loadingSave">取消</el-button>
                <el-button type="primary" @click="submitData" :loading="loadingSave">确定</el-button>
            </template> -->
        </el-dialog>
    </div>
</template>

<script>
    import {apiDeviceUpdata,apiUploadImg} from "@/api/api";
    import LyDialog3 from "@/components/dialog/dialog3";
    import XEUtils from "xe-utils";
    import {deepClone} from "@/utils/util";
    import { url } from '@/api/url';
    export default {
        components: {LyDialog3},
        emits: ['addDeviceData'],
        name: "addDevice",
        data() {
            return {
                dialogVisible:false,
                loadingSave:false,
                loadingTitle:'',
                devcieInfo:{
                    id: 0,
                    name: "",
                    group_name: "",
                    type: 0,
                    model: "",
                    sn: "",
                    power: 0,
                    manufactor: "",
                    location: "",
                    status: 0,
                    location_x: 0,
                    location_y: 0,
                    pic_url: "",
                    env_pic_url: "",
                    is_fix_freq:"",
                    load_output_speed:"",
                    speed:"",
                    alg_delay:6,
                    enable_stopped_event_output:false
                },
                pic_url : "",
                env_pic_url : "",
                rules:{
                    model: [
                        {required: true, message: '请输入设备型号',trigger: 'blur'}
                    ],
                    sn: [
                        {required: true, message: '请输入设备编号',trigger: 'blur'}
                    ],
                    power: [
                        {required: true, message: '请输入设备功率',trigger: 'blur'}
                    ],
                    manufactor: [
                        {required: true, message: '请输入生产厂家',trigger: 'blur'}
                    ],
                    location: [
                        {required: true, message: '请输入设备位置',trigger: 'blur'}
                    ],
                    speed: [
                        {required: true, message: '请输入转速 单位:转/分钟',trigger: 'blur'}
                    ],
                    alg_delay: [
                        {required: true, message: '请输入算法延时时间 单位:分钟',trigger: 'blur'}
                    ],

                },
                defaultAddDevImg:'this.src="'+require('../../../assets/bigscreen/addDevPic.jpg')+'"',
                defaultAddEnvImg:'this.src="'+require('../../../assets/bigscreen/addEnvPic.jpg')+'"', 
            }
        },

        methods:{
            handleClose() {
                this.dialogVisible=false
                this.loadingSave=false

                this.devcieInfo.model = ""
                this.devcieInfo.sn = ""
                this.devcieInfo.power = 0
                this.devcieInfo.manufactor = ""
                this.devcieInfo.location = ""
                this.devcieInfo.pic_url = ""
                this.devcieInfo.env_pic_url = ""
                this.devcieInfo.load_output_speed =""
                this.devcieInfo.is_fix_freq =""

                this.pic_url = ""
                this.env_pic_url = ""
                
                this.devcieInfo.speed = null
                this.devcieInfo.alg_delay = null
                this.devcieInfo.enable_stopped_event_output = null
            },

            addDeviceFn(item,flag) {
                this.loadingTitle=flag
                this.dialogVisible=true
                
                if(item){
                    this.devcieInfo = deepClone(item)
                }
       
                if(this.devcieInfo.is_fix_freq){
                    this.devcieInfo.is_fix_freq = "定频"
                }else this.devcieInfo.is_fix_freq = "变频"


               


                //代理模式下要替换URL
                if(!(this.devcieInfo.pic_url == "" || this.devcieInfo.pic_url == null)){
                    if ( !this.devcieInfo.pic_url.includes(url)) {
                        this.pic_url = url + this.devcieInfo.pic_url.split("//")[1].split("/").slice(1).join("/")
                    }
                }

                if(!(this.devcieInfo.env_pic_url == "" || this.devcieInfo.env_pic_url == null)){
                    if ( !this.devcieInfo.env_pic_url.includes(url)) {
                        this.env_pic_url = url + this.devcieInfo.env_pic_url.split("//")[1].split("/").slice(1).join("/")
                    }
                }            
            },

            submitData() {
                this.$refs['rulesForm'].validate(obj=>{
                    if(obj) {
                       
                        
                        this.loadingSave=true
                        let devinfo_data = {
                
                            id: this.devcieInfo.id,
                            name:this.devcieInfo.name,
                            type: this.devcieInfo.type,
                            model:this.devcieInfo.model,
                            sn:this.devcieInfo.sn,
                            power: this.devcieInfo.power,
                            manufactor: this.devcieInfo.manufactor,
                            location: this.devcieInfo.location,
                            is_fix_freq:this.devcieInfo.location=="定频" ? 1:0,
                            load_output_speed:this.devcieInfo.load_output_speed,
                            speed:this.devcieInfo.speed,
                            alg_delay:this.devcieInfo.alg_delay,
                            enable_stopped_event_output:this.devcieInfo.enable_stopped_event_output
                        }
                        apiDeviceUpdata(devinfo_data).then(res=>{
                           
                            if(res.code ==200) {
                                this.loadingSave=false
                                this.$message.success("设备信息上传成功")
                                this.handleClose()
                                this.$emit('addDeviceData',{id:this.devcieInfo.id})
                            } else {
                                this.loadingSave=false
                                this.$message.warning("设备信息上传失败")
                            }
                        }) .catch(res => {  
                            this.loadingSave=false
                            this.$message.warning(`设备信息上传失败 : ${res.msg}`)
                            return 
                        });
                    }
                })
            },

            checkImage(file){
                const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
                const isLt1M = file.size / 1024 / 1024 < 5; 
                if (!isJPG) {
                    this.$message.error('图片只能是 JPG/PNG 格式!');
                    return false
                }
                if (!isLt1M) {
                    this.$message.error('图片大小不能超过5MB！');
                    return false;
                }
                return isJPG;
            },

            imgBeforeUploadDevice(file) {
                return this.checkImage(file)
            },
            async imgUploadRequestDevice(param) {
                var vm = this
                try {
                    let obj = await apiUploadImg(param);
                    if(obj.code == 200) {
                        vm.devcieInfo.pic_url = obj.data.pic_url
                        if(!(obj.data.pic_url == "" || obj.data.pic_url ==null ) ){
                            // vm.pic_url = url + "media" + obj.data.pic_url.split("/media")[1] 
                            var pic_split = obj.data.pic_url.split("//")[1].split("/").slice(1).join("/")
                            vm.pic_url = url + pic_split

                            vm.devcieInfo.pic_url = obj.data.pic_url
                        }
                        else
                            vm.pic_url = ""
                    }
                } catch (error) {
                    console.error(error);
                    this.$message.warning(`图片获取失败`)
                }
            },
            imgUploadSuccessDevice() {
                this.$refs.uploadDefaultImageDevice.clearFiles()
            },


            imgBeforeUploadEnv(file) {
                return this.checkImage(file)
            },
            async imgUploadRequestEnv(param) {
                var vm = this
                try {
                    let obj = await apiUploadImg(param);
                    if(obj.code == 200) {
                        if(!(obj.data.pic_url == "" || obj.data.pic_url ==null) ){
                            // vm.env_pic_url = url + "media" + obj.data.pic_url.split("/media")[1]
                            var pic_split = obj.data.pic_url.split("//")[1].split("/").slice(1).join("/")
                            vm.env_pic_url = url + pic_split

                            vm.devcieInfo.env_pic_url = obj.data.pic_url
                        } 
                        else
                            vm.env_pic_url = ""
                    }
                } catch (error) {
                    console.error(error);
                    this.$message.warning(`图片获取失败`)
                }
            },
            imgUploadSuccessEnv() {
                this.$refs.uploadDefaultImageEnv.clearFiles()
            },
        }
    }
</script>

<style lang="scss" scoped>
    :deep(.custom-dialog)  {
    

    
    background: url("@/assets/bigscreen/alarm_handle.png") no-repeat center center;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;


    }
    :deep(.el-input__wrapper){
    background-color: #fff;

    }
    :deep(.el-input__inner){
    color: black;

    }


    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 50px;
      color: #8c939d;
      width: 280px;
      height: 200px;
    }
    .avatar {
      width: 280px;
      height: 200px;
      display: block;
    }

    .upload_form-input_class1{
        // background-color: white;
        width:300px;
    }

    .upload_form-input_class1 .el-input__wrapper {
        box-shadow: 0 0 0 0px; 
    }



</style>
